




import { Component, Vue } from "vue-property-decorator";
import MyApp from "@/components/MyApp.vue"; // @ is an alias to /src

@Component({
  components: {
    MyApp
  }
})
export default class MyAppPage extends Vue {}
